import { ref } from 'vue'

const STORAGE_KEY = 'dsgvo_consent'

// null = undecided, 'accepted' = consented, 'rejected' = declined
export const consentStatus = ref(localStorage.getItem(STORAGE_KEY))

export function giveConsent() {
  localStorage.setItem(STORAGE_KEY, 'accepted')
  consentStatus.value = 'accepted'
}

export function rejectConsent() {
  localStorage.setItem(STORAGE_KEY, 'rejected')
  consentStatus.value = 'rejected'
}

export function resetConsent() {
  localStorage.removeItem(STORAGE_KEY)
  consentStatus.value = null
}

export function hasConsent() {
  return consentStatus.value === 'accepted'
}
